import { css } from 'styled-components';

export const headerContainerStyle = css`
  border-top-left-radius: 30px;
  border-top-right-radius: 30px;
`;

